import * as Calcs from './calcs';

const Private = {
  perYear: function (costPerMile, milesDrivenAnnually) {
    if (!costPerMile || !milesDrivenAnnually) return 0;
    return costPerMile * milesDrivenAnnually;
  },

  perMonth: function (costPerMile, milesDrivenAnnually) {
    if (!costPerMile || !milesDrivenAnnually) return 0;
    return this.perYear(costPerMile, milesDrivenAnnually) / 12;
  },

  total: function (costPerMile, milesDrivenAnnually, monthsOfOwnership) {
    if (!costPerMile || !milesDrivenAnnually || !monthsOfOwnership) return 0;
    return this.perMonth(costPerMile, milesDrivenAnnually) * monthsOfOwnership;
  },
};

// vehicle could be electric or gas
const calcTotalCostOfOwnership = (
  vehicle,
  purchaseMethod,
  monthsOfOwnership,
  milesDrivenAnnually,
  interestRateAsBasisPoints,
  electricMilesPortionForPhev,
  gasolinePriceInCentsPerGal,
  includeResaleValue,
  includeChargerCosts,
  salesTax,
  downPayment,
  costPublicCharging,
  publicChargingPercentage,
  municipality,
  electricityRate,
  insuranceData,
  maintenanceData,
  evRegistraionFeesRegion
) => {
  let vehicleCostPerMile = Calcs.VehicleCost.perMile(
    vehicle,
    milesDrivenAnnually,
    monthsOfOwnership,
    interestRateAsBasisPoints,
    purchaseMethod,
    includeResaleValue,
    salesTax,
    downPayment
  );
  let electricityPerMile = Calcs.ElectricityCost.perMile(
    vehicle,
    electricityRate,
    electricMilesPortionForPhev,
    costPublicCharging,
    publicChargingPercentage
  );
  let gasPerMile = Calcs.GasolineCost.perMile(
    vehicle,
    electricMilesPortionForPhev,
    gasolinePriceInCentsPerGal
  );
    let summedPerMileVehicle =
      vehicleCostPerMile + electricityPerMile + gasPerMile;

  function calculatePremiumInsurance(data, year) {
    let sum = 0;
    for (const item of data) {
      if (item.year_reference <= year) {
        sum += item.insurance_premium;
      } else {
        break;
      }
    }
    return sum;
  }
  function calculateMaintenanceCost(data, year) {
    let sum = 0;
    for (const item of data) {
      if (item.year_reference <= year) {
        sum += item.annual_cost;
      } else {
        break;
      }
    }
    return sum;
  }

  function calculateTaxsFees(vehicle, evRegistraionFeesRegion) {
    return vehicle.equivalent_gas_vehicle
      ? (salesTax / 100) * vehicle.msrp + evRegistraionFeesRegion
      : (salesTax / 100) * vehicle.msrp;
  }


  let insuranceCost =
    (insuranceData?.length &&
      calculatePremiumInsurance(insuranceData, monthsOfOwnership / 12)) ||
    0;
  let maintenanceCost =
    (maintenanceData?.length &&
      calculateMaintenanceCost(maintenanceData, monthsOfOwnership / 12)) ||
    0;

  if (vehicle && !vehicle.equivalent_gas_vehicle) {
    insuranceCost = insuranceCost * 0.75;
    maintenanceCost = maintenanceCost * 0.7;
  }

  return {
    vehicle: {
      perMile: vehicleCostPerMile,
      perMonth: Private.perMonth(vehicleCostPerMile, milesDrivenAnnually),
      perYear: Private.perYear(vehicleCostPerMile, milesDrivenAnnually),
      total: Private.total(
        vehicleCostPerMile,
        milesDrivenAnnually,
        monthsOfOwnership
      ),
    },
    taxesFees: {
      total: calculateTaxsFees(vehicle, evRegistraionFeesRegion),
    },
    charger: {
      total:
        (vehicle.fuel === 'BEV' || vehicle.fuel === 'PHEV') &&
        includeChargerCosts
          ? 1800
          : 0, // hardcoded for PHEV and EV
    },
    electricity: {
      perMile: electricityPerMile,
      perMonth: Private.perMonth(electricityPerMile, milesDrivenAnnually),
      perYear: Private.perYear(electricityPerMile, milesDrivenAnnually),
      total: Private.total(
        electricityPerMile,
        milesDrivenAnnually,
        monthsOfOwnership
      ),
    },
    gasoline: {
      perMile: gasPerMile,
      perMonth: Private.perMonth(gasPerMile, milesDrivenAnnually),
      perYear: Private.perYear(gasPerMile, milesDrivenAnnually),
      total: Private.total(gasPerMile, milesDrivenAnnually, monthsOfOwnership),
    },
    maintenance: {
      total: maintenanceCost,
    },
    insurance: {
      total: insuranceCost,
    },
    summed: {
      perMile: summedPerMileVehicle,
      perMonth: Private.perMonth(summedPerMileVehicle, milesDrivenAnnually),
      perYear: Private.perYear(summedPerMileVehicle, milesDrivenAnnually),
      total:
        Private.total(summedPerMileVehicle, milesDrivenAnnually, monthsOfOwnership) +
        maintenanceCost + insuranceCost,
      totalLastYear:
        Private.total(
          vehicleCostPerMile,
          milesDrivenAnnually,
          monthsOfOwnership
        ) +
        calculateTaxsFees(vehicle, evRegistraionFeesRegion) +
        ((vehicle.fuel === 'BEV' || vehicle.fuel === 'PHEV') &&
        includeChargerCosts
          ? 1800
          : 0) +
        Private.total(
          electricityPerMile,
          milesDrivenAnnually,
          monthsOfOwnership
        ) +
        Private.total(gasPerMile, milesDrivenAnnually, monthsOfOwnership) +
        maintenanceCost + insuranceCost,
    },
    car: vehicle,
  };
};

export default calcTotalCostOfOwnership;
